import React, { useState } from "react"
import { APIPost } from "../../API";
import { Input } from "../../c/Input";
import { Col } from "reactstrap";
import { T, TraksConsumer } from "../../traks";
import { AlertModal } from "../../c/Modals";
import { useNavigate } from "react-router-dom";
import AuthBody from "../../c/AuthBody";
import { PasswordErrorText, passwordValidator, RePasswordErrorText, rePasswordValidator } from "../../c/Input/InputValidators";
import { LL } from "../../c/LL";


const ResetPassword = ({ sessionId, handleSubmit, password, setPassword, ...props }) => {
	const [showRequiredWarnings, setShowRequiredWarnings] = useState(false)

	let [verifyCred, setVerifyCred] = useState({
		password2: '',
	});

	const formIsValid = () => {
		return passwordValidator(password)
			&& rePasswordValidator(verifyCred.password2, password)
	}

	const handleSignup = () => {
		if (!formIsValid()) {
			setShowRequiredWarnings(true)
		} else {
			handleSubmit()
		}
	}

	return (
		<div className="d-flex flex-column align-items-center w-100 vh-100 justify-content-between">
			<div className="pt-3 pt-lg-5">
				<img src='https://static.sibilus.eu/gfx/pentus-logo-0.svg' className="w-50" alt='our logo' />
			</div>
			<Col xs={12} lg={6} className="mx-auto">
				<div className="pb-4">
					<div className="fw_600">
						<h3><T>Reset password</T></h3>
					</div>
					<div className="dark-grey">
						<T>Create new password here.</T>
					</div>
				</div>
				<form onSubmit={(e) => e.preventDefault()} className="w-100 pb-5">
					<PasswordErrorText value={password} showEmptyWarning={showRequiredWarnings} />
					<Input
						rounded
						className="w-100 mt-3 border_radius_6px"
						dataCy="password"
            id={"password"}
						placeholder={<T>Password</T>}
						type="password"
						onChange={(password) => setPassword(password)}
					/>
					<div className="mt-3">
						<RePasswordErrorText value={verifyCred.password2} refValue={password} showEmptyWarning={showRequiredWarnings} />
						<Input
							rounded
							className="w-100 mt-3 border_radius_6px"
              id={"passwordAgain"}
							dataCy="password-again"
							autocomplete="off"
							type="password"
							placeholder={<T>Password again</T>}
							onChange={(password2) =>
								setVerifyCred({
									...verifyCred,
									password2,
								})
							}
						/>
					</div>
					<button
						className="text-white font_15px btn btn_green w-100 mt-5"
						disabled={password.length === 0}
						onClick={(e) => {
							e.preventDefault();
							handleSignup();
						}}
					>
						<T>Save password</T>
					</button>
				</form>
			</Col>
			<div className="pb-5">
				<span className="me-3"><T>Back to login?</T></span>
				<a className="link_nostyle fw_600 primary" href={LL("/login")}><T>Login</T></a>
			</div>
		</div>
	)
}

const CreatePasswordPage = () => {
	const navigate = useNavigate();
	const queryStringParams = new URLSearchParams(window.location.search);
	const sessionId = queryStringParams.get('session_id')
	const [password, setPassword] = useState('')
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)

	const handleSubmit = () => {
		setShowLoading(true)
		APIPost("resetpassword", { password, session_id: sessionId }).then(res => {
			setShowLoading(false)
			setAlertType({ text: "your password was reset", type: "success" })
			setShowAlert(true)
			setTimeout(() => navigate(LL('/login')), 500);
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ text: "Something went wrong", type: "error" })
			setShowAlert(true)
			console.log(err)
		})
	}


	if (!sessionId) {
		return <></>
	}

	return (
		<>
			<AuthBody showLoading={showLoading}>
				<TraksConsumer>
					<ResetPassword
						sessionId={sessionId}
						handleSubmit={handleSubmit}
						password={password}
						setPassword={setPassword} />
				</TraksConsumer>
			</AuthBody>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>
	);
}

export default CreatePasswordPage
